import { RewardsComingSoon } from "@/components/rewards/RewardsComingSoon";

/**
 * Dormant SPIF claim detail — parked behind the Rewards "coming soon"
 * placeholder (CHP-430) so a direct URL never surfaces the old claim detail.
 * The SpifStatusBadge / detail components stay on disk for later revival.
 * Rewards is NOT cancelled — see ADR-0033 (supersedes ADR-0031 §4).
 */
export function PartnerSpifDetailRoute() {
  return <RewardsComingSoon audience="partner" />;
}
